const imageSource = "//cdn.shopify.com/s/files/1/0404/0196/1115/t/85/assets/bliss-black.png";
let product_data_object = false;
let product_variant_id = false;
let meta_fields = false;
let CurrentDate = new Date();
var thumbs;
var slider;

/**
 * @method openCart
 * @description For Open the Cart Drawer
*/
function openCart() {
    $("#cart-drawer").trigger("click");
}

/**
 * @method closePopup
 * @description For Close The Model Popup
*/
function closePopup() {
    product_data_object = false;
    product_variant_id = false;
    meta_fields = false;
    $("#product__popup").hide();
    $("#response-success").hide();
    $("#response-failed").hide();
    $("#product_popup_loader").show();
    $("#wishlist-variant-id").val('');
    $("#addTocartProd").attr("data-itemid", "");
    $("#addTocartProd").attr("data-user", "");
}

/**
 * @method wishlistToBag
 * @param (this) data
 * @description For Close The Model Popup
*/
function wishlistToBag(data) {
    let product = parseInt($(data).data("product"));
    let variant = parseInt($(data).data("variant"));
    let handle = $(data).data("handle");
    meta_fields = $(data).data("meta");
    let productData = fetchProduct(handle);
    product_variant_id = variant;
  
    $("#product__popup").show();
    $("#product_popup_loader").parent().css('overflow-y','hidden');
   
    productData.then(function(result) {
        if (result) {
            updateProductPopup(result);
            $("#product_popup_loader").hide();
            $("#product_popup_loader").parent().css('overflow-y','auto');
            $("#addTocartProd").attr("data-itemid", $(data).data("itemid"));
            $("#addTocartProd").attr("data-user", $(data).data("user"));
        }
    }).catch(function(err) {
        console.error(err);
    });
}

/**
 * @method fetchProduct
 * @param (string) handle
 * @description For fetch product with shopify ajax api
*/
async function fetchProduct(handle) {
    if (handle) {
        const shop_url = window.location.protocol + "//" + window.location.host;
        let getProductWithVariants = await fetch(`${shop_url}/products/${handle}.js`);
        getProductWithVariants = await getProductWithVariants.json();
        return getProductWithVariants;
    }
    return false;
}

/**
 * @method updateProductPopup
 * @param (object) data
 * @description For update the popup content
*/
function updateProductPopup(data) {
    product_data_object = data;
    updateProductContent(data);
    updateSliderImages(data);
}


/**
 * @method updateSliderImages
 * @param (object) data
 * @description For update slide content
*/
function updateSliderImages(data) {
    chooseProductVariant();
    let option1Value = $('input[name="option-0"]:checked').val();
    let option2Value = $('input[name="option-1"]:checked').val();
    let option3Value = $('input[name="option-3"]:checked').val();
    GalleryChange(data.media, option1Value, option2Value, option3Value);
}

/**
 * @method updateProductContent
 * @param (object) data
 * @description For product content
*/
function updateProductContent(data) {
    // Product title
    $(".ProductMeta__Title").text(data['title']);
    // Compare Price
    $(".Price--compareAt").text('Rs.' + paisaToRupees(data['compare_at_price']));
    // Price
    $(".ProductMeta__Price").text('Rs.' + paisaToRupees(data['price']));
    updateProductReview(data['id']);
    $('.color_variant_wrapper').hide();
    $('.size_variant_wrapper').hide();
    $('.length_variant_wrapper').hide();
    $(".ColorSwatchList").html('');
    $(".SizeSwatchList").html('');
    $(".LengthSwatchList").html('');


    data['options'].forEach(function(value) {
        if (value['name'] == 'Color' || value['name'] == 'Colour') {
            // Update Color Options
            $('.color_variant_wrapper').show();
            colorVariantRender(value['values']);
        } else if (value['name'] == 'Size') {
            // Update Size Options
            $('.size_variant_wrapper').show();
            sizeVariantRender(value['values']);
        } else if (value['name'] == 'Length') {
            // Update Length Options
            $('.length_variant_wrapper').show();
            lengthVariantRender(value['values']);
        }
    });
}

/**
 * @method colorVariantRender
 * @param (object) data
 * @description For update color swatches
*/
function colorVariantRender(data) {
    let productHideColorTag = product_data_object.tags;
    let colorItemsArray = null;
    productHideColorTag.forEach(function(value) {
        if (value.match(/colorHide/gi)) {
            let colorItems = value.split("_");
            colorItemsArray = colorItems[colorItems.length - 1].split('|');
        }
    });
    data.forEach(function(color, index) {
        if (colorItemsArray != null && colorItemsArray.includes(`${index+1}`)) {
            return;
        }
        let imgName = color.toLowerCase().replace(/\s+/g, "-");
        let imageSrc = imageSource.replace("bliss-black", imgName);
        $(".ColorSwatchList").append(`
        <li>
            <input id="option-template--${color}__main-0-0" class="sr-only ColorSwatch__Radio" type="radio" name="option-0" value="${color}" data-option-position="1" onchange="updateVariantId('color')">
            <label 
              for="option-template--${color}__main-0-0" 
              class="ColorSwatch ColorSwatch--large color-swatch rounded-full" 
              data-tooltip="${color}"
              style="--swatch-background: url(${imageSrc})"
            >            
                 <span class="sr-only">${color}</span>
           </label>
        </li>`);
    });
}

/**
 * @method sizeVariantRender
 * @param (object) data
 * @description For update size swatches
*/
function sizeVariantRender(data) {
    data.forEach(function(size) {
        $(".SizeSwatchList").append(`<li class="size-li-${size}">
          <input id="option-template--${size}__main-1-0" class="sr-only SizeSwatch__Radio size-input-${size}" type="radio" name="option-1" value="${size}" data-option-position="2" onchange="updateVariantId('size')">
          <label for="option-template--${size}__main-1-0" class="SizeSwatch size-label-${size} block-swatch">${size}</label>
          </li>`);
    });
}

/**
 * @method lengthVariantRender
 * @param (object) data
 * @description For update length swatches
*/
function lengthVariantRender(data) {
    data.forEach(function(length) {
        $(".LengthSwatchList").append(`<li class="size-li-${length}">
          <input id="option-template--${length}__main-1-0" class="sr-only LengthSwatch__Radio length-input-${length}" type="radio" name="option-3" value="${length}" data-option-position="3" onchange="updateVariantId('length')">
          <label for="option-template--${length}__main-1-0" class="LengthSwatch length-label-${length.replace(/[^A-Z0-9]+/ig, "_")} block-swatch">${length}</label>
          </li>`);
    });
}

/**
 * @method paisaToRupees
 * @param (int) amount
 * @description For convert paisa to inr
*/
function paisaToRupees(amount) {
    if (amount) return (amount / 100).toFixed(2);
}

/**
 * @method addToCart
 * @param (object) data
 * @description For add to cart the selected product
*/
async function addToCart(data) {
    $(".product_add_to_cart_btn").text("Adding . . .");
    let variantId = $('#wishlist-variant-id').val();   
    let formData = {
        'items': [{
            'id': variantId,
            'quantity': 1
        }]
    };
    let add_to_cart = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    });

    try {
        if (add_to_cart.ok && add_to_cart.status == 200) {
            let responseData = await add_to_cart.json();
            document.dispatchEvent(new CustomEvent('cart:build', {
                bubbles: true
            }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true //this code is for prestige theme, is to refresh the cart
            }));
            $("#response-failed").hide();
            $("#response-success").show();
            removeItemAfterAddToCart($(data).attr("data-itemid"));
        } else {
            throw add_to_cart;
        }
    } catch (err) {
        var errMessage = await err.json();
        $("#response-success").hide();
        $("#response-failed").html(errMessage.description);
        $("#response-failed").show();
        console.log(errMessage.description);
    }
    $(".product_add_to_cart_btn").text("Add to cart");
}

/**
 * @method GalleryChange
 * @param (object) productMedia, (string) color, (string) size, (string) length
 * @description For add to cart the selected product
*/
function GalleryChange(productMedia, color = null, size = "all", length = null) {
    let gallerySlider = document.querySelector('#gallerySlider .swiper-wrapper');
    let galleryThumb = document.querySelector('#galleryThumb .swiper-wrapper');
    let finalImages = ""; //get current active images
    let gallery = '';
    let thumb = '';
    let initFlag = false;
    let imgCount = 0;
    let newsrc = "";
    let setImage = true;
  
    //Foreach the slider images  
    if (size == "all") {
        productMedia = productMedia.slice(0, 8)
    }
    
    $(".swiper-notification").remove();
    productMedia.forEach(function(value, index) {
        let altArr = value.alt != null ? value.alt.split(",").map((item) => item.trim()) : [];
        setImage = true;
        
        // For size handle
        if (value.alt != null && value.alt != 'hide' && altArr.includes(size) && altArr.includes(color) && length == null && setImage) {
            check = false;
            imgCount = imgCount + 1
            initFlag = true;
            newsrc = value.src

            gallery += "<div class='swiper-slide'>";
            gallery += `<a href="javascript:void(0)" class="productLightBox">`;
            gallery += `<img src="${newsrc}" class="swiper-lazy"> `;
            gallery += "</a>";
            gallery += "</div>";

            thumb += "<div class='swiper-slide'>";
            thumb += `<img src="${newsrc}" class="swiper-lazy"> `;
            thumb += "</div>";
        }

        // Length Handle
        if (altArr.includes(color) && altArr.includes(length) && altArr.includes(size) && length != null && value.alt != null && value.alt != 'hide' && setImage) {

            check = false;
            imgCount = imgCount + 1
            initFlag = true;
            newsrc = value.src

            gallery += "<div class='swiper-slide'>";
            gallery += `<a href="javascript:void(0)" class="productLightBox">`;
            gallery += `<img src="${newsrc}" class="swiper-lazy"> `;
            gallery += "</a>";
            gallery += "</div>";

            thumb += "<div class='swiper-slide'>";
            thumb += `<img src="${newsrc}" class="swiper-lazy"> `;
            thumb += "</div>";
        }

    });
    if (initFlag) {
        gallerySlider.innerHTML = gallery;
        galleryThumb.innerHTML = thumb;
        updateGallerySlider();
    } else {
        let i = 0;
        productMedia.forEach(function(value, index) {
            if (value.alt != 'hide') {
                newsrc = value.src;

                gallery += "<div class='swiper-slide'>";
                gallery += `<a href="javascript:void(0)" class="productLightBox">`;
                gallery += `<img src="${newsrc}" class="swiper-lazy"> `;
                gallery += "</a>";
                gallery += "</div>";

                thumb += "<div class='swiper-slide'>";
                thumb += `<img src="${newsrc}" class="swiper-lazy"> `;
                thumb += "</div>";
            }
        });
        gallerySlider.innerHTML = gallery;
        galleryThumb.innerHTML = thumb;
        updateGallerySlider();
    }
    setTimeout(function() {
        $("#gallery-loader").hide();
    }, 200);
}

/**
 * @self-invoke
 * @description For initialise swiper slider gallery
*/
(function(){

    // Swiper slider thumbnail initialise
    thumbs = new Swiper('.gallery-thumbs', {
        slidesPerView: 5,
        spaceBetween: 5,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    // Swiper slider slider initialise  
    slider = new Swiper('.gallery-slider', {
        slidesPerView: 1,
        spaceBetween: 5,
        centeredSlides: true,
        simulateTouch: false,

        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        thumbs: {
            swiper: thumbs,
        },
    });
}());

/**
 * @method updateGallerySlider
 * @description For update slider gallery
*/
function updateGallerySlider() {
    thumbs.update();
    slider.update();
}

/**
 * @method updateVariantId
 * @param (string) type, (bool) onload
 * @description For update variant during swatch
*/
function updateVariantId(type = 'color', onload = false) {
    let option1Value = $('input[name="option-0"]:checked').val();
    let option2Value = $('input[name="option-1"]:checked').val();
    let option3Value = $('input[name="option-3"]:checked').val();
    let isFound = false;
    let isAvailable = false;
    let variantId = 0;
    let variantValuesData = false;
    let variAvail = false;
    let prodUnAvail = [];
    let badgeText = "";
    const newLunchText = "NEW LAUNCH";
    let addToCartLbl = "Add to cart";

    if (type == "color") {
        $('.SizeSwatch').addClass('varaint-disabled');
        $('.lbl-Color').text('  ' + option1Value);
        if (typeof option3Value != 'undefined') {

            $('.LengthSwatch').addClass('varaint-disabled');
        }
    } else if (type == "size") {
        $('.lbl-Size').text('  ' + option2Value);
        if (typeof option3Value != 'undefined') {

            $('.LengthSwatch').addClass('varaint-disabled');
        }
    } else {
        if (typeof option3Value != 'undefined') {
            $('.lbl-Length').text('  ' + option3Value);
        }
    }

    product_data_object.variants.forEach(function(variantValues) {
        var item = product_data_object;

        if (typeof item.media !== "undefined") {
            if (type == 'color' && variantValues.option1 === option1Value) {
                GalleryChange(item.media, option1Value);
            } else if (variantValues.option1 === option1Value && variantValues.option2 === option2Value && typeof option3Value == 'undefined') {
                GalleryChange(item.media, option1Value, option2Value)
            } else if (typeof option3Value != 'undefined' && variantValues.option1 === option1Value && variantValues.option2 === option2Value && variantValues.option3 === option3Value) {
                GalleryChange(item.media, option1Value, option2Value, option3Value);
            }
        }

        //color handle
        if (type == "color" || (type == "size" && typeof option3Value != 'undefined')) {
            if (variantValues.option1 === option1Value) {

                if (variantValues.available) {
                    $('.size-label-' + variantValues.option2).removeClass('varaint-disabled');
                    if (typeof option3Value != 'undefined' && type == "color") {
                        $('.length-label-' + variantValues.option3.replace(/[^A-Z0-9]+/ig, "_")).removeClass('varaint-disabled');
                    }

                } else {

                    if (variantValues.available) {
                        $('.size-label-' + variantValues.option2).removeClass('varaint-disabled');
                        if (typeof option3Value != 'undefined' && variantValues.option2 === option2Value) {
                            $('.length-label-' + variantValues.option3.replace(/[^A-Z0-9]+/ig, "_")).removeClass('varaint-disabled');
                        }
                    }
                }
            }
        }

        //size handle
        if (variantValues.option1 === option1Value && variantValues.option2 === option2Value) {
            isFound = true;
            variantValuesData = variantValues;
            addToCartLbl = "Add to cart";
            variantId = variantValues.id;
            if (variantValues.option3 != null) {
                isFound = true
                option3Size = true;
                isAvailable = variAvail
                if (!variAvail) {
                    isAvailable = variantValues.available;
                }
                if (variantValues.option3 == option3Value) {
                    prodUnAvail.push(option3Value);
                }
                if (variantValues.available) {
                    if (typeof option3Value != 'undefined' && variantValues.option2 === option2Value) {
                        $('.length-label-' + variantValues.option3.replace(/[^A-Z0-9]+/ig, "_")).removeClass('varaint-disabled');
                    }
                }
            } else {
                isAvailable = variantValues.available;
                addToCartLbl = "Add to cart";
                if (variantValues.available) {
                    if (typeof option3Value != 'undefined' && variantValues.option2 === option2Value) {
                        $('.length-label-' + variantValues.option3.replace(/[^A-Z0-9]+/ig, "_")).removeClass('varaint-disabled');
                    }
                }

                $('#Color-ProductId').val(parseFloat(variantValues.id));
            }

            $('.Price--highlight').text("Rs. " + addCommas(Math.round(item.price / 100)));
            if (item.compare_at_price != null) {
                $('.Price--compareAt').text("Rs. " + addCommas(Math.round(item.compare_at_price / 100)));
            }
            $('.ProductMeta__PriceList').css('display', 'block');
        }

        //length handle
        if (variantValues.option1 === option1Value && variantValues.option2 === option2Value && variantValues.option3 === option3Value) {
            variantValuesData = variantValues;
            isFound = true;
            isAvailable = variantValues.available;
            addToCartLbl = "Add to cart";

            $('#Color-ProductId').val(parseFloat(variantValues.id));
            $('.Price--highlight').text("Rs. " + addCommas(Math.round(item.price / 100)));
            if (item.compare_at_price != null) {
                $('.Price--compareAt').text("Rs. " + addCommas(Math.round(item.compare_at_price / 100)));
            }
            $('.ProductMeta__PriceList').css('display', 'block');
            variAvail = variantValues.available;
        }


    });

    // Update Badge
    $('.product__tag').html('');
    meta_fields['badges'].forEach(function(badgeVariant) {
        if (badgeVariant[0] == variantId) {
            if (badgeVariant[1] !== "") {
                badgeUpdate = true;
                badgeText = badgeVariant[1];
                const isNewLunchClass = (badgeText.toLowerCase() == newLunchText.toLowerCase()) ? "tag-new-launch" : '';
                const badegList = `<li id="color-group-badge" class="product__tag-item ${isNewLunchClass}">${badgeText}</li>`;
                $('.product__tag').html(badegList);
                return false
            }
        }
    });

    // Update Preorder 
    if (!isAvailable) {
        meta_fields['pre_orders'].forEach(function(preOrders) {
            if (preOrders[0] == variantId) {
                let SelectedDate = new Date(preOrders[1]);
                addToCartLbl = "Pre-order - dispatch on " + SelectedDate.toDateString();
                if (CurrentDate > SelectedDate) {
                    addToCartLbl = "Pre-order";
                }
                return false;
            }
        });
    }

    $('#wishlist-variant-id').val(variantId);

    if (isAvailable || variAvail) {
        $('#addTocartProd').text(addToCartLbl);
        $('#addTocartProd').prop('disabled', false);
        $('#addTocartProd').removeClass('disabled');
        $('#addTocartProd').css('pointer-events', '');
        $('#addTocartProd').css('color', '#fff');
    } else {
        if (isFound) {
            $('#addTocartProd').text('Sold Out');
        } else {
            $('#addTocartProd').text('Unavailable');
        }

        $('#addTocartProd').prop('disabled', true);     
        $('#addTocartProd').css('pointer-events', 'none');
    }

    if (product_data_object.options.length == 3 && !prodUnAvail.includes(option3Value)) {
        $('#addTocartProd').text('Unavailable');
        $('#addTocartProd').prop('disabled', true); 
        $('#addTocartProd').css('pointer-events', 'none');
    }

}

/**
 * @method addCommas
 * @param (int) nStr
 * @description For format price
*/
function addCommas(nStr) {
    nStr += '';
    x = nStr.split('.');
    x1 = x[0];
    x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}

/**
 * @method chooseProductVariant
 * @description For select options based on variant id
*/
function chooseProductVariant() {
    let variantData = null;
    if (!isNaN(product_variant_id) && product_variant_id != false) {
        product_data_object['variants'].forEach(function(value) {
            if (value.id == product_variant_id) {
                variantData = value;
            }
        });
        $('#wishlist-variant-id').val(product_variant_id);
        // color choose
        if (variantData.option1 != null) {
            $('input[name="option-0"]').filter('[value="' + variantData.option1 + '"]').attr('checked', true).trigger('change');
            $('.lbl-Color').text('  ' + variantData.option1);
        }
        // size choose
        if (variantData.option2 != null) {
            $('input[name="option-1"]').filter('[value="' + variantData.option2 + '"]').attr('checked', true).trigger('change');
            $('.lbl-Size').text('  ' + variantData.option2);
        }
        // Length choose
        if (variantData.option3 != null) {
            $('input[name="option-3"]').filter('[value="' + variantData.option3 + '"]').attr('checked', true).trigger('change');
            $('.lbl-Length').text('  ' + variantData.option3);
        }
    }
    let ColorOption = $('input[name="option-0"]');
    let sizeOption = $('input[name="option-1"]');
    let lengthOption = $('input[name="option-3"]');
    if (typeof ColorOption != 'undefined' && !$(ColorOption).is(':checked')) {
        $('input[name="option-0"]:first').attr('checked', true).trigger('change');
        $('.lbl-Color').text('  ' + $('input[name="option-0"]:first').val());
    }
    if (typeof sizeOption != 'undefined' && !$(sizeOption).is(':checked')) {
        $('input[name="option-1"]:first').attr('checked', true).trigger('change');
        $('.lbl-Size').text('  ' + $('input[name="option-1"]:first').val());
    }
    if (typeof lengthOption != 'undefined' && !$(lengthOption).is(':checked')) {
        $('input[name="option-3"]:first').attr('checked', true).trigger('change');
        $('.lbl-Length').text('  ' + $('input[name="option-3"]:first').val());
    }
}

/**
 * @method updateProductReview
 * @param (int) productID
 * @description For get judge me product reviews
*/
async function updateProductReview(productID = null) {
    if (productID != null) {
        var public_token = "ZLAQWkQagU8bfTI1QeZ62db-Prw";
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };
        var judge_me_review = await fetch(`https://cache.judge.me/widgets/shopify/myblissclub.myshopify.com?public_token=${public_token}&preview_badge_product_ids=${productID}`, requestOptions);
        var judge_me_review_result = await judge_me_review.json();
        var judge_me_review_html = judge_me_review_result.preview_badges[productID];
        $("#product_review").html(judge_me_review_html);
    }
}

/**
 * @method removeItemAfterAddToCart
 * @param (int) item_id, 
 * @description For remove the wishlist after add to cart
*/
async function removeItemAfterAddToCart(item_id = null) {
  let remove_button = $(`.item-remove-btn[data-itemid="${item_id}"]`);
  remove_button.click();
}

/**
 * @method openSizeChart
 * @param (array) chart
 * @description For open size chart
*/
function openSizeChart(chart) {
    if (meta_fields['size_chart'] && meta_fields['size_chart'][0] && meta_fields['size_chart'][0][1] && meta_fields['size_chart'][0][1][chart] != null) {
        var imageUrl = meta_fields['size_chart'][0][1][chart];
        $("#size_chart_popup").show();
        $("#size_chart_image").html(`<img src="${imageUrl}" class="size_chart_image" />`);
    }
}

/**
 * @method closeSizeChart
 * @description For close size chart
*/
function closeSizeChart() {
    $("#size_chart_popup").hide();
    $("#size_chart_image").html('');
}